import { ExtensionService } from './../../../core/service/extension.service';
import { Component, OnInit, Input, OnChanges, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { CaseService } from 'src/app/core/service/case.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/core/service/user.service';
import { groupBy, sortBy, orderBy } from 'lodash';
import { ChannelTotals } from 'src/app/channel/model/channelTotals';
import { MessageSubject, MessengerService } from 'src/app/core/service/messenger.service';
import { LocalStorageService } from 'ngx-webstorage';
import { CollapsibleComponent } from 'src/app/shared/collapsible/collapsible.component';
import { Subscription } from 'rxjs';
import { SettingService } from 'src/app/core/service/setting.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';

@Component({
  selector: 'app-dashboard-coordinator-middle',
  templateUrl: './dashboard-coordinator-middle.component.html',
  styleUrls: ['./dashboard-coordinator-middle.component.scss']
})
export class DashboardCoordinatorMiddleComponent implements OnInit, OnChanges, OnDestroy
{
  @ViewChildren('collapsibles') public collapsibles: QueryList<CollapsibleComponent>;

  @Input() public filter: any;
  @Input() public groupBy: string;
  @Input() public sortBy: string;
  @Input() public sortDirection: string;

  public performanceList: any[] = [];
  public middleLoading = true;
  public isDashboardEnrollmentEnabled = false;
  public labelYou = '';
  public labelTeam = '';
  public messageDialogOpened = false;
  public messageSendTo = '';
  public performanceTotalList: any[];
  public groupedPerformanceList: any[];
  public collapsedSections = new Map<string, boolean>();
  public channelTotals = new ChannelTotals();
  public resumeFilters = '';
  public collapse = false;
  public savingMessage = false;
  public patientLabel = {};
  public searchMembersToEnroll = false;
  public enrollChannelId = null;
  public enrollChannelName = null;
  public nextAvailableEnabled: boolean = false;
  public selectedEnrollmentTab = 0;
  public onChangeLoading = false;

  private messagingSubscription: Subscription;

  constructor(
    private caseService: CaseService,
    private translate: TranslateService,
    private userService: UserService,
    private messengerService: MessengerService,
    private storageService: LocalStorageService,
    private extensionService: ExtensionService,
    private messageHandlerService: MessageHandlerService,
    private settingService: SettingService)
  {
    this.messagingSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'dashboardGroupCollapsedChild' && message.data)
        {
          this.collapse = message.data.event;
          this.onChangeCollapse(this.collapse);
          this.updateProgramCollapse(message.data.group, message.data.event);
        }
      }
    });
  }

  /**
   * Return true if channels are grouped.
   */
  public get isGrouped(): boolean
  {
    return (this.groupBy !== undefined && this.groupBy !== null && this.groupBy !== '');
  }

  /**
   * Return true if channels are sorted.
   */
  public get isSorted(): boolean
  {
    return (this.sortBy !== undefined && this.sortBy !== null && this.sortBy !== '');
  }

  public ngOnDestroy(): void
  {
    if (this.messagingSubscription !== undefined) { this.messagingSubscription.unsubscribe(); }
  }

  public barColor = (point): string => (point.value.target === null || point.value.current >= point.value.target) ? '#589BB3' : '#e96b62';

  public ngOnInit(): void
  {
    this.translate.get(['YOU', 'TEAM']).subscribe({
      next: (res: any) =>
      {
        this.labelYou = res.YOU;
        this.labelTeam = res.TEAM;
      }
    });

    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
      }
    });
  }

  public sendMessageToProgramLead(id: number): void
  {
    this.userService.getUserById(id, false).subscribe({
      next: (user) =>
      {
        this.messageSendTo = user.username;
        this.messageDialogOpened = true;
      }
    });
  }

  public ngOnChanges(): void
  {
    if (this.onChangeLoading) { return; };  // Just prevent re-call during loading for Performance

    this.onChangeLoading = true;
    this.performanceList = [];
    this.groupedPerformanceList = [];
    let performanceList = [];
    let groupedPerformanceList = [];
    this.middleLoading = true;
    this.isDashboardEnrollmentEnabled = false;
    this.caseService.getPerformanceDashboard().subscribe({
      next: (data) =>
      {
        data.forEach(d =>
        {
          d.performanceUser = ((d.userCasesCloseOnTime !== null && d.totalUserCasesClose !== null) ?
            (d.userCasesCloseOnTime * 100 / d.totalUserCasesClose).toFixed(0) : 0);
          d.performanceTeam = ((d.teamCasesCloseOnTime !== null && d.totalCasesClose !== null) ?
            (d.teamCasesCloseOnTime * 100 / d.totalCasesClose).toFixed(0) : 0);
          d.programGrouper = d.programName + '|' + d.programId;
          performanceList.push(d);
          if (d.isDashboardEnrollment)
          {
            this.isDashboardEnrollmentEnabled = true;
          }
        });

        this.performanceTotalList = performanceList;
        this.middleLoading = false;
        if (this.performanceTotalList !== undefined)
        {
          performanceList = this.performanceTotalList;
          if (this.filter !== undefined &&
            ((this.filter.filterCategory !== null && this.filter.filterCategory.length > 0) ||
              (this.filter.filterByStatus !== null && this.filter.filterByStatus.length > 0) ||
              (this.filter.filterByProgramName !== null && this.filter.filterByProgramName.length > 0) ||
              (this.filter.filterByChannelName !== null && this.filter.filterByChannelName.length > 0)))
          {
            if (this.filter.filterCategory !== null && this.filter.filterCategory.length > 0)
            {
              performanceList = performanceList.filter(x => this.filter.filterCategory.includes(x.programCategory));
            }
            if (this.filter.filterByStatus !== null && this.filter.filterByStatus.length > 0)
            {
              performanceList = performanceList.filter(x => this.filter.filterByStatus.includes(x.channelStatus));
            }
            if (this.filter.filterByProgramName !== null && this.filter.filterByProgramName.length > 0)
            {
              performanceList = performanceList.filter(x => x.programName.toLowerCase()
                .includes(this.filter.filterByProgramName.toLowerCase()));
            }
            if (this.filter.filterByChannelName !== null && this.filter.filterByChannelName.length > 0)
            {
              performanceList = performanceList.filter(x => x.channelName.toLowerCase()
                .includes(this.filter.filterByChannelName.toLowerCase()));
            }
          }

          // Create groups if needed
          if (this.groupBy !== undefined && this.groupBy !== null)
          {
            let grouped;
            switch (this.groupBy)
            {
              case 'category':
                grouped = groupBy(sortBy(performanceList, 'programCategoryName'), 'programCategoryName');
                break;
              case 'status':
                grouped = groupBy(sortBy(performanceList, 'channelStatus'), 'channelStatus');
                break;
              case 'program':
                grouped = groupBy(sortBy(performanceList, 'programName'), 'programGrouper');
                break;
            }

            // Set grouped view
            groupedPerformanceList = Object.keys(grouped).map(
              group => ({
                group,
                performanceList: (this.isSorted) ?
                  this.applySort(grouped[group], this.sortBy, this.sortDirection) : grouped[group],
                totals: new ChannelTotals()
              })
            );
            performanceList = [];
            this.collapsedSections = new Map<string, boolean>();
            groupedPerformanceList.forEach(group =>
            {
              const storedCollapsedStatus = this.storageService.retrieve('collapsible-section-dashboard-list-' + group.group);
              this.collapsedSections.set(group.group, storedCollapsedStatus !== null ? storedCollapsedStatus : this.collapse);
              if (storedCollapsedStatus !== null && storedCollapsedStatus === false)
              {
                this.collapse = false;
                this.messengerService.sendMessage(new MessageSubject('dashboardGroupCollapsedParent', false));
              }
              const totalsGroup = new ChannelTotals();
              group.performanceList.forEach(p =>
              {
                totalsGroup.closedCases += p.totalUserCasesClose;
                totalsGroup.lateTasks += p.lateTasks;
                totalsGroup.openCases += p.openCases;
                totalsGroup.programLead = p.programLead;
                totalsGroup.programName = p.programName;
                totalsGroup.programId = p.programId;
                totalsGroup.programLeadId = p.programLeadId;
              });
              group.totals = totalsGroup;
            });
          }
          else
          {
            groupedPerformanceList = [];
            // Apply sort
            if (this.isSorted)
            {
              performanceList = this.applySort(performanceList, this.sortBy, this.sortDirection);
            }
            else
            {
              performanceList = orderBy(performanceList, ['channelName'], 'desc');
            }

            // Recalculate filtered totals
            this.resetTotals();
            this.performanceTotalList.forEach(p =>
            {
              this.channelTotals.closedCases += p.totalUserCasesClose;
              this.channelTotals.lateTasks += p.lateTasks;
              this.channelTotals.openCases += p.openCases;
              this.channelTotals.programLeadId = p.programLeadId;
              this.channelTotals.programLead = p.programLead;
            });
          }
        }

        // Set global variable only once when all completed
        this.performanceList = performanceList;
        this.groupedPerformanceList = groupedPerformanceList;

        // This is a work around for the component design flaw. ngOnchanges was received in the dashboard-coordinator-top-left.component
        // when changing filter prior updating the performanceList. This message will force a counts refresh after data is loaded.
        this.messengerService.sendMessage(new MessageSubject('refreshDashboardCounts'));

        setTimeout(() => { this.onChangeLoading = false; });
      }
    });
  }

  /**
   * Apply Sorting
   *
   * @param performanceList Object to sort.
   * @param sort Sort property.
   * @param sortDirection Sort direction.
   */
  public applySort(performanceList: any[], sort: string, sortDirection: string): any[]
  {
    const directionArray = [];

    directionArray.push(sortDirection);

    return orderBy(performanceList, [sort], directionArray);
  }

  public onChangeCollapse(event: boolean): void
  {
    if (this.collapsibles !== undefined)
    {
      this.collapsibles.forEach((collapsable) =>
      {
        if (this.collapse)
        {
          if (!collapsable.collapsed)
          {
            collapsable.toggleChange();
          }
        }
        else if (collapsable.collapsed)
        {
          collapsable.toggleChange();
        }
      });
    }
    this.collapse = event;
  }

  public updateProgramCollapse(group: string, event: boolean): void
  {
    this.collapsedSections[group] = event;
    if (!event)
    {
      this.collapse = false;
      this.messengerService.sendMessage(new MessageSubject('dashboardGroupCollapsedParent', false));
    }
  }

  public channelToggle(group: string): void
  {
    if (this.collapsibles)
    {
      this.collapsibles.forEach((collapsable) =>
      {
        if (collapsable.storageKey === `dashboard-list-${group}`)
        {
          collapsable.toggleChange();
          return;
        }
      });
    }
  }

  public enrollPatient(channelId: number, channelName: string): void
  {
    this.enrollChannelId = channelId;
    this.enrollChannelName = channelName;
    this.extensionService.getExtensionsByCategory('PATIENT', true).subscribe({
      next: (data) =>
      {
        this.nextAvailableEnabled = data.filter((x: any) => x.enabledNextAvailable && x.enabled &&
          (x.allChannels || x.channels.map((x: any) => x.channelId).includes(channelId))).length > 0;
        this.selectedEnrollmentTab = this.nextAvailableEnabled ? 0 : 1;
        this.searchMembersToEnroll = true;
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  public completedEnrollments(): void
  {
    this.messageHandlerService.displaySuccess('ENROLLMENT-COMPLETED');
    this.closeMemberEnrollmentModal();
  }

  public closeMemberEnrollmentModal(): void
  {
    this.searchMembersToEnroll = false;
  }

  private resetTotals(): void
  {
    this.channelTotals.openCases = 0;
    this.channelTotals.lateTasks = 0;
    this.channelTotals.closedCases = 0;
  }
}
